import { userApi } from './api';

// The homebase loads `GET /tenants` from two places on the same page render —
// the shell chrome (module switcher access) and the workspace view (tenant
// cards). Coalesce them onto one in-flight request so a single page load makes
// a single call. Callers that need fresh data (Retry, post-provisioning) pass
// `force`. Errors clear the cache so the next call retries, and surface to the
// caller — the workspace view renders its own inline error + Retry.
let inflight: Promise<any[]> | null = null;

export function fetchTenants(force = false): Promise<any[]> {
  if (force || !inflight) {
    inflight = userApi
      .get('/tenants', { suppressGlobalError: true })
      .then((res) => (res.data || []) as any[])
      .catch((err) => {
        inflight = null;
        throw err;
      });
  }
  return inflight;
}
